class Blog {
    constructor(){
        let readMore = $('.readMore');
        this.blogVerticalLine = $('#blog-menu').find('.blog-category');

        readMore.on('click', '#get-more-articles', event => {
            let that = $(event.target).closest('#get-more-articles');
            let page =that.data('page');
            let categorySlug =  that.data('category');
            let url = '/blog/getArticles/' + categorySlug;

            $.get(url, {page: page}, 'json').done( event =>  {
                this.addNewArticles(event, '#get-more-articles', '#more-articles');
            });
        });

        readMore.on('click', '#get-search-articles', event => {
            let that = $(event.target).closest('#get-search-articles');
            let page = that.data('page');
            let query =  that.data('search');

            $.get('/blog/getSearchArticles', {query:query, page: page}, 'json').done( event =>  {
                this.addNewArticles(event, '#get-search-articles', '#blog-search-items');
            })
        });

        readMore.on('click', '#get-more-author-articles', event => {
            let that = $(event.target).closest('#get-more-author-articles');
            let page = that.data('page');
            let user =  that.data('user');

            $.get('/blog/getAuthorArticles', {user:user, page: page}, 'json').done( event =>  {
                this.addNewArticles(event, '#get-more-author-articles', '#more-articles');
            })
        });

        $('.blogMenu').on('click', '.js-toggle', function(event){
            let that = $(this);
            let parentGroup = that.closest('.toggleGroup');
            if (parentGroup.hasClass('is-active')) {
                parentGroup.removeClass('is-active')
            } else {
                parentGroup.addClass('is-active');
            }
        });

        this.verticalLineCategory();
        this.initialVerticalLineAfterResize();
    }

    addNewArticles(event, elementId, inputElementId) {
        let articlesHtml = event.html || '';
        let showMoreArticles = event.showMoreArticles || false;
        let moreArticlesElement = $(elementId);
        let page = +moreArticlesElement.data('page');
        $(articlesHtml).hide().appendTo(inputElementId).fadeIn();
        if (!showMoreArticles) {
            moreArticlesElement.closest('.contentContainer').hide();
        } else {
            moreArticlesElement.data('page', page+1);
        }
    }

    verticalLineCategory() {
        let lastElement = false;
        this.blogVerticalLine.each(function () {
            if (lastElement && (lastElement.offset().top !== $(this).offset().top)) {
                lastElement.find('.blog-vertical-line').addClass("no-vertical-line");
            }
            lastElement = $(this);
        });
    }

    initialVerticalLineAfterResize() {
        let that = this;
        if (this.blogVerticalLine.length > 0) {
            $( window ).resize(function() {
                that.blogVerticalLine.each(function () {
                    $(this).find('.blog-vertical-line').removeClass("no-vertical-line");
                });
                setTimeout(function () {
                    that.verticalLineCategory();
                },0);

            });
        }
    }
}

$(document).ready(function () {
    new Blog();
});